// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
import Vuex from 'vuex';
Vue.use(Vuex);
//表格自适应
import Plugin from 'v-fit-columns';
Vue.use(Plugin);
// 字体自适应
import 'lib-flexible'
// 引入icon
import './assets/icon/iconfont.css'
//引入公共验证
import VueBus from 'vue-bus'
Vue.use(VueBus)
// 规则
import rules from "./api/rules"
import VueQuillEditor from 'vue-quill-editor'
// 引入公共样式
import "./static/css/common.css"

// 引入公共方法
import utils from "./api/utils.js"
Vue.prototype.$utils = utils


// 移动端底部tabbar 引入全部组件
import Mint from 'mint-ui';
import { Indicator } from 'mint-ui'
import 'mint-ui/lib/style.css'

import 'jquery'

// 引入echarts
// import echarts from 'echarts'
//引入富文本css
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import echarts from 'echarts'  //引入echarts
// 全局引入json
// import list from "./utils/fieList.json"

Vue.use(VueQuillEditor, /* { default global options } */)
// 挂载到原型上
Vue.prototype.$rules = rules;
// Vue.prototype.$echarts = echarts
import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})
// 图片放大功能1
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'


// 微信卡片
import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx


// 抖音sdk
// import dySdk from "../src/SDK/dy_sdk"
// Vue.prototype.$dySdk = dySdk

// 移动端底部
import mobileFooter from '../src/components/mobileFooter.vue'
Vue.component('mobileFooter', mobileFooter)

// 移动端用户管理单独的表格
import accontTable from '../src/components/accontTable.vue'
Vue.component('accontTable', accontTable)
// 单位管理表格
import unitTable from '../src/components/unitTable.vue'
Vue.component('unitTable', unitTable)

// 移动端表格
import mtTable from '../src/components/mtTable.vue'
Vue.component('mtTable', mtTable)


// import './utils/adapter.min'
// import WebRtcStreamer from './utils/webrtcstreamer.js'
// Vue.use(WebRtcStreamer)


import mtDataList from '../src/components/mtDataList.vue'
Vue.component('mtDataList', mtDataList)

Vue.use(VueDirectiveImagePreviewer)
// 图片放大功能2
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Vue.use(Mint);
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        const ariaEls = el.querySelectorAll('.el-radio__original')
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden')
        })
    }
})


// 路由拦截器
router.beforeEach((to, from, next) => {
    next();
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: {
        App
    },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js